import React, { Component } from "react";
import { withNamespaces } from "react-i18next";

import DataTable from "../../../components/Datatable/DataTable";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
// import StringInput from "../../../components/Input/StringInput/StringInput";
// import NumberInput from "../../components/Input/NumberInput/NumberInput";
import Button from "../../../components/Button/Button";
import DateTimePicker from "../../../components/DateTimePicker/DateTimePicker";
import Skeleton from "react-loading-skeleton";
import StringInput from "../../../components/Input/StringInput/StringInput";
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai";
import UpdownArrow from '../../../assets/images/updown-arrow.png'
import { numFormat } from "../../../hoc/Shared/utility";

class MemberBettingHistoryListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCard: false,
    };
  }

  noFormatter = (cell, row, rowIndex) => {
    // let rowNumber = (this.props.activePage - 1) * this.props.limit + (rowIndex + 1);
    let rowNumber =
      this.props.totalRecords - rowIndex - (this.props.activePage - 1) * this.props.limit;
    return <span>{rowNumber}</span>;
  };

  titleCase = (str) => {
    let splitStr = str.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  };

  toggleCard = () => {
    this.setState({
      showCard: !this.state.showCard,
    });
  };

  totalFormatter(column, colIndex, { text }) {
    return (
      <div>
        <p className="sub-total">{column["footer"][0]}</p>
        <p>( {column["footer"][1]} )</p>
      </div>
    );
  }

  totalBetAmountFormatter(column, colIndex, { text }) {
    return (
      <div>
        <p className="sub-total">{column["footer"][0]}</p>
        <p>( {column["footer"][1]} )</p>
      </div>
    );
  }

  totalWinLoseAmountFormatter(column, colIndex, { text }) {
    return (
      <div>
        <p className="sub-total">{column["footer"][0]}</p>
        <p>( {column["footer"][1]} )</p>
      </div>
    );
  }

  render() {
    const { t, i18n } = this.props;
    let dataListing = [];
    let gn_val = "";
    const num_format = numFormat(this.props.memberCurrency);
    // let sub_total_bet_amount = 0;
    // let total_bet_amount = 0;
    // let total_win_lose_amount = 0;
    // let win_lose_amount = 0;
    // let payoutAmount = 0;
    // let total_valid_turnover = 0;
    // let sub_total_valid_turnover = 0;

    if (this.props.data) {
      dataListing = this.props.data.map((val, idx) => {
        // if (val.table_id !== null) {
        //   if (i18n.exists(`games:${val.vendor_slug}.${val.table_id}`)) {
        //     gn_val = t(`games:${val.vendor_slug}.${val.table_id}`);
        //   } else {
        //     gn_val = val.table_id;
        //   }
        // } else {
        //   gn_val = val.table_id;
        // }

        if(val.game_title !== null){
          gn_val = val.game_title;
        }else{
          gn_val = (i18n.exists(`games:${val.vendor_slug}.${val.table_id}`)) ? t(`games:${val.vendor_slug}.${val.table_id}`) : val.table_id;
        }

        const category = val.game_slug.substring(val.game_slug.indexOf('_') + 1);

        return {
          no: idx,
          update_date: val.update_date,
          vendor_slug: t(`vendor.${val.vendor_slug}`),
          game_slug: t(`game-type.${category}`),
          game_title: gn_val,
          ref_id: val.ref_id,
          bet_no: val.bet_no,
          bet_amount: new Intl.NumberFormat("en-US", num_format).format(val.bet_amount),
          payout_amount: <span className={`${parseFloat(val.payout_amount) > 0 ? `text-success` : parseFloat(val.payout_amount) < 0 ? `text-danger` : `badge badge-pill badge-primary`}`}>{new Intl.NumberFormat("en-US", num_format).format(Math.abs(parseFloat(val.payout_amount)))}</span>,
          win_lose_amount: <span className={`${parseFloat(val.win_lose_amount) > 0 ? `text-success` : parseFloat(val.win_lose_amount) < 0 ? `text-danger` : `badge badge-pill badge-primary`}`}>{new Intl.NumberFormat("en-US", num_format).format(Math.abs(parseFloat(val.win_lose_amount)))}</span>,
          turnover: new Intl.NumberFormat("en-US", num_format).format(val.turnover),
          result: val.result ? t(`game-result.${val.result}`) : '-',
          // result: parseFloat(val.betAmount) === parseFloat(val.payoutAmount) ? 'draw' : parseFloat(val.payoutAmount) > parseFloat(val.betAmount) ? 'win' : 'lose',
        };
      });
    }

    const columns = [
      { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "100px", textAlign: "center" }, footer: [t("global.sub-total"), t("global.total")], footerFormatter: this.totalFormatter, footerClasses: 'table-footer' },
      { text: t("member.transaction-date"), dataField: "update_date", sort: true, onSort: this.props.onSort, footer: "" },
      { text: t("member.game-vendor"), dataField: "vendor_slug", sort: true, onSort: this.props.onSort, footer: "" },
      { text: t("member.game-type"), dataField: "game_slug", sort: true, onSort: this.props.onSort, footer: "" },
      { text: t("member.game-name"), dataField: "game_title", sort: true, onSort: this.props.onSort, footer: "" },
      { text: t("member.ref-id"), dataField: "ref_id", sort: true, onSort: this.props.onSort, footer: "" },
      { text: t("member.bet-no"), dataField: "bet_no", sort: true, onSort: this.props.onSort, footer: "" },
      {
        text: t("member.bet-amount"),
        dataField: "bet_amount",
        sort: true,
        onSort: this.props.onSort,
        headerStyle: { width: "120px" },
        footer: [
          new Intl.NumberFormat("en-US", num_format).format(this.props.subTotalBetAmt).toString(),
          new Intl.NumberFormat("en-US", num_format).format(this.props.totalBetAmt).toString()
        ],
        footerFormatter: this.totalBetAmountFormatter,
        footerClasses: 'table-footer'
      },
      {
        text: t("member.payout"),
        dataField: "payout_amount",
        sort: true, onSort: this.props.onSort,
        headerStyle: { width: "120px" },
        footer: [
          <span className={`${parseFloat(this.props.subTotalPayoutAmt) > 0 ? `text-success` : parseFloat(this.props.subTotalPayoutAmt) < 0 ? `text-danger` : `badge badge-pill badge-primary`}`}>{new Intl.NumberFormat("en-US", num_format).format(Math.abs(parseFloat(this.props.subTotalPayoutAmt)))}</span>,
          <span className={`${parseFloat(this.props.totalPayoutAmt) > 0 ? `text-success` : parseFloat(this.props.totalPayoutAmt) < 0 ? `text-danger` : `badge badge-pill badge-primary`}`}>{new Intl.NumberFormat("en-US", num_format).format(Math.abs(parseFloat(this.props.totalPayoutAmt)))}</span>
        ],
        footerFormatter: this.totalWinLoseAmountFormatter,
        footerClasses: 'table-footer'
      },
      {
        text: t("member.win-lose"),
        dataField: "win_lose_amount",
        sort: true, onSort: this.props.onSort,
        headerStyle: { width: "120px" },
        footer: [
          <span className={`${parseFloat(this.props.subTotalWinLoseAmt) > 0 ? `text-success` : parseFloat(this.props.subTotalWinLoseAmt) < 0 ? `text-danger` : `badge badge-pill badge-primary`}`}>{new Intl.NumberFormat("en-US", num_format).format(Math.abs(parseFloat(this.props.subTotalWinLoseAmt)))}</span>,
          <span className={`${parseFloat(this.props.totalWinLoseAmt) > 0 ? `text-success` : parseFloat(this.props.totalWinLoseAmt) < 0 ? `text-danger` : `badge badge-pill badge-primary`}`}>{new Intl.NumberFormat("en-US", num_format).format(Math.abs(parseFloat(this.props.totalWinLoseAmt)))}</span>
        ],
        footerFormatter: this.totalWinLoseAmountFormatter,
        footerClasses: 'table-footer'
      },
      {
        text: t("member.valid-turnover"),
        dataField: "turnover", sort: true,
        onSort: this.props.onSort,
        headerStyle: { width: "120px" },
        footer: [
          new Intl.NumberFormat("en-US", num_format).format(this.props.subTotalTurnoverAmt).toString(),
          new Intl.NumberFormat("en-US", num_format).format(this.props.totalTurnoverAmt).toString()
        ],
        footerFormatter: this.totalBetAmountFormatter,
        footerClasses: 'table-footer'
      },
      { text: t("member.result"), dataField: "result", sort: true, onSort: this.props.onSort, footer: "" },
    ];

    /* ======================== datatables data assign [END] ======================== */

    return (
      <Auxiliary>
        <div className="row row-sm">
          <div className="col-xl-12">
            <div className="card card-body card-primary">
              <div className="">
                {this.props.loading ? (
                  <Skeleton count={2} />
                ) : (
                  <form
                    method="post"
                    id="transaction_form"
                    className={`form-horizontal filter-function row ${this.state.showCard ? "open" : "close"
                      } filter-wrapper-1`}
                  >
                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label className="font-weight-bolder">
                          {t("member.transaction-date")}
                        </label>
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="fas fa-calendar-check"></i>
                          </span>
                          <DateTimePicker
                            id="transaction_date"
                            name="transaction_date"
                            className="form-control filter-input"
                            range={true}
                            timePicker={true}
                            value={this.props.filter.transaction_date}
                            onChange={this.props.onInputChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label htmlFor="ref_id" className="font-weight-bolder">
                          {t("member.ref-id")}
                        </label>
                        <StringInput
                          id="ref_id"
                          name="ref_id"
                          type="text"
                          value={this.props.filter.ref_id}
                          onChange={this.props.onInputChange}
                          className="form-control filter-input"
                          onSearchPress={(evt) =>
                            evt.key === "Enter" && this.props.refreshHandler()
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label htmlFor="ref_id" className="font-weight-bolder">
                          {t("member.bet-no")}
                        </label>
                        <StringInput
                          id="bet_no"
                          name="bet_no"
                          type="text"
                          value={this.props.filter.bet_no}
                          onChange={this.props.onInputChange}
                          className="form-control filter-input"
                          onSearchPress={(evt) =>
                            evt.key === "Enter" && this.props.refreshHandler()
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label htmlFor="game_title" className="font-weight-bolder">
                          {t('member.game-title')}
                        </label>
                        <StringInput 
                          id="game_title"
                          name="game_title"
                          type="text"
                          value={this.props.filter.game_title}
                          onChange={this.props.onInputChange}
                          onSearchPress={(e) => e.key === 'Enter' && this.props.refreshHandler()}
                        />
                      </div>
                    </div> */}

                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label className="font-weight-bolder">
                          {t("member.game-vendor")}
                        </label>
                        <div className="select-input">
                          <select
                            className="form-control filter-input"
                            id="vendor"
                            name="vendor"
                            onChange={this.props.onInputChange}
                            value={this.props.filter.vendor}
                          >
                            <option value=""></option>
                            {/* {this.props.ddTransactionType} */}
                            {this.props.ddGameVendor &&
                              this.props.ddGameVendor.map((val) => {
                                return (
                                  <option key={val.id} value={val.id}>
                                    {t(`vendor.${val.slug}`)}
                                  </option>
                                );
                              })}
                          </select>
                          <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label className="font-weight-bolder">
                          {t("member.game-type")}
                        </label>
                        <div className="select-input">
                          <select
                            className="form-control filter-input"
                            id="category"
                            name="category"
                            onChange={this.props.onInputChange}
                            value={this.props.filter.category}
                          >
                            <option value=""></option>
                            {this.props.ddGameType &&
                              this.props.ddGameType.map((val) => {
                                let tempTitle = this.titleCase(val.title).toLowerCase();
                                return (
                                  <option key={val.id} value={val.id}>
                                    {/* {this.titleCase(val.title)} */}
                                    {t(`game-type.${tempTitle}`)}
                                  </option>
                                );
                              })}
                          </select>
                          <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                        </div>

                      </div>
                    </div>

                    <div className="col-md-3 col-6">
                      <div className="form-group">
                        <label htmlFor="vendor" className="font-weight-bolder">
                          {t("game-betslip.group-ref-id")}
                        </label>
                        <div className="select-input">
                          <select
                            className="form-control filter-input"
                            id="group_ref_id"
                            name="group_ref_id"
                            onChange={this.props.onInputChange}
                            value={this.props.filter.group_ref_id}>
                            <option value="2">{t("game-betslip._no")}</option>
                            <option value="1">{t("game-betslip._yes")}</option>
                          </select>
                          <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                        </div>

                      </div>
                    </div>

                    <div className="col mt-auto">
                      <div className="d-flex">
                        <Button
                          typeButton="button"
                          classValue="btn btn-blue mr-2"
                          idValue="filter"
                          buttonName={t("global.filter")}
                          clicked={() => this.props.refreshHandler()}
                        />
                        <Button
                          typeButton="button"
                          classValue="btn btn-secondary"
                          idValue="reset"
                          buttonName={t("global.reset")}
                          clicked={() => this.props.clearHandler()}
                        />
                      </div>
                    </div>
                  </form>
                )}
              </div>

              <div className="show-btn" onClick={() => this.toggleCard()}>
                {this.state.showCard ? (
                  <AiFillMinusCircle />
                ) : (
                  <AiFillPlusCircle />
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header pb-0">
                <div className="d-flex justify-content-between">
                  <h4 className="card-title mg-b-0">
                    {t("member.betting-history")}
                  </h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive table-hover datatable">
                  <DataTable
                    keyField="no"
                    data={dataListing}
                    columns={columns}
                    activePage={this.props.activePage}
                    limit={this.props.limit}
                    totalItems={this.props.totalRecords}
                    paginationHandler={(val) =>
                      this.props.datatablesChangeHandler(val, "activePage")
                    }
                    sizePerPageHandler={(val) =>
                      this.props.datatablesChangeHandler(val, "limit")
                    }
                    searchChangeHandler={(val) =>
                      this.props.datatablesChangeHandler(val, "searchValue")
                    }
                    searchValue={this.props.searchValue}
                    classValue="dataTable table-bordered text-justify text-center"
                    loading={this.props.loading}
                    hideSearchBar={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Auxiliary>
    );
  }
}

export default withNamespaces("translation")(MemberBettingHistoryListing);
